/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_YesInputs */

const en_us2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const pt_br2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const es_419_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const pt_pt2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

const fr_fr2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_de2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_it2_intake_yes = /** @type {(inputs: Intake_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Intake_YesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_yes = /** @type {((inputs?: Intake_YesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_YesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_yes(inputs)
	if (locale === "es-419") return es_419_intake_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_yes(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_yes(inputs)
	if (locale === "de-DE") return de_de2_intake_yes(inputs)
	if (locale === "it-IT") return it_it2_intake_yes(inputs)
	return en_us2_intake_yes(inputs)
});
export { intake_yes as "intake.yes" }